enum ChatBotVendorType {
  XENO = "XENO"
}

export default ChatBotVendorType;
